import { Injectable } from '@angular/core';

import { ParagraphDividerData } from '@generated/content';
import { CmsComponentConfig, Divider } from '@interfaces/config';

import { BaseComponentResolver } from '../../../_base/base-component-resolver/base-component-resolver';

@Injectable({ providedIn: 'root' })
export class DividerComponentResolver extends BaseComponentResolver {
  static override instance: DividerComponentResolver;
  private readonly componentType = Divider.TypeEnum;

  static getInstance(): DividerComponentResolver {
    return (DividerComponentResolver.instance ||= new DividerComponentResolver());
  }

  public override resolveComponentConfig(
    node: ParagraphDividerData
  ): CmsComponentConfig<Divider.ComponentConfig> | null {
    if (!node) {
      return null;
    }
    return {
      componentType: this.componentType,
      config: {
        nodeId: BaseComponentResolver.getNodeId(node),
        styled: !!!node.attributes?.field_without_syling_divider,
      },
    };
  }
}
